import React, { useState } from "react";
import { Clock } from "lucide-react";
import { api } from "../api/client";
import { useAuth } from "../contexts/AuthContext";
import { useToast } from "../contexts/ToastContext";

export const BannerContaSuspensa = () => {
  const { user, setUser } = useAuth();
  const toast = useToast();
  const [enviando, setEnviando] = useState(false);
  if (!user?.suspenso_em) return null;

  const reativar = async () => {
    setEnviando(true);
    try {
      const r = await api.fetch('/usuarios/me/reativar', { method: 'POST' });
      if (!r.ok) {
        const j = await r.json().catch(() => ({}));
        throw new Error(j.detail || 'Falha ao reativar.');
      }
      if (setUser) setUser(prev => ({ ...prev, suspenso_em: null }));
      toast.sucesso('Conta reativada! Seus anúncios voltaram às buscas.');
    } catch (e) {
      toast.erro(e.message);
    } finally { setEnviando(false); }
  };

  return (
    <div className="bg-orange-50 border-b border-orange-200 px-4 py-2.5 flex items-center gap-3">
      <Clock size={16} className="text-orange-600 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold text-orange-900">Sua conta está suspensa</p>
        <p className="text-[10px] text-orange-700 truncate">Anúncios fora das buscas. Reative quando quiser.</p>
      </div>
      <button
        disabled={enviando}
        onClick={reativar}
        className="px-3 py-1.5 rounded-lg bg-orange-600 text-white text-xs font-bold hover:bg-orange-700 disabled:bg-slate-300 flex-shrink-0"
      >
        {enviando ? '...' : 'Reativar'}
      </button>
    </div>
  );
};
